var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useState } from 'react';
import AlertDialog from './AlertDialog';
import ConfirmDialog from './ConfirmDialog';
import { DialogContext, } from './DialogContext';
var CONFIRM_DEFAULT_OPTIONS = {
    title: '',
    content: '',
    cancellationText: 'FECHAR',
    confirmationText: 'CONFIRMAR',
};
var ALERT_DEFAULT_OPTIONS = {
    title: '',
    content: '',
    okText: 'OK',
};
export var DialogProvider = function (_a) {
    var children = _a.children;
    var _b = useAlert(), alert = _b.alert, alertOption = _b.alertOption, handleOk = _b.handleOk;
    var _c = useConfirm(), confirm = _c.confirm, confirmOption = _c.confirmOption, handleConfirm = _c.handleConfirm, handleCancel = _c.handleCancel;
    return (_jsxs(DialogContext.Provider, { value: {
            alert: alert,
            confirm: confirm,
        }, children: [children, _jsx(ConfirmDialog, __assign({ open: !!confirmOption }, confirmOption, { onConfirm: handleConfirm, onCancel: handleCancel })), _jsx(AlertDialog, __assign({ open: !!alertOption }, alertOption, { onClick: handleOk }))] }));
};
function useAlert() {
    var _a = useState(null), resolvePromise = _a[0], setResolvePromise = _a[1];
    var _b = useState(null), alertOption = _b[0], setAlertOption = _b[1];
    var alert = useCallback(function (option) {
        setAlertOption(__assign(__assign({}, ALERT_DEFAULT_OPTIONS), option));
        return new Promise(function (resolve) {
            setResolvePromise(function () { return function (value) {
                if (value) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }; });
        });
    }, []);
    var handleOk = useCallback(function () {
        setAlertOption(null);
        if (resolvePromise) {
            resolvePromise(true);
        }
    }, [resolvePromise]);
    return { alert: alert, alertOption: alertOption, handleOk: handleOk };
}
function useConfirm() {
    var _a = useState(null), resolvePromise = _a[0], setResolvePromise = _a[1];
    var _b = useState(null), confirmOption = _b[0], setConfirmOption = _b[1];
    var confirm = useCallback(function (option) {
        setConfirmOption(__assign(__assign({}, CONFIRM_DEFAULT_OPTIONS), option));
        return new Promise(function (resolve) {
            setResolvePromise(function () { return function (value) {
                if (value) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            }; });
        });
    }, []);
    var handleConfirm = useCallback(function () {
        setConfirmOption(null);
        if (resolvePromise) {
            resolvePromise(true);
        }
    }, [resolvePromise]);
    var handleCancel = useCallback(function () {
        setConfirmOption(null);
        if (resolvePromise) {
            resolvePromise(false);
        }
    }, [resolvePromise]);
    return { confirm: confirm, confirmOption: confirmOption, handleConfirm: handleConfirm, handleCancel: handleCancel };
}
